// extracted by mini-css-extract-plugin
export var cardTitle = "_j0-1";
export var commentBubble = "_j0-e";
export var commentForm = "_j0-a";
export var commentInput = "_j0-b";
export var commentLabel = "_j0-d";
export var commentPrompt = "_j0-9";
export var csatCard = "_j0-0";
export var feedbackSection = "_j0-7";
export var starDisabled = "_j0-6";
export var starEmpty = "_j0-5";
export var starFilled = "_j0-4";
export var starWrapper = "_j0-3";
export var starsContainer = "_j0-2";
export var submittedComment = "_j0-c";
export var thankYouText = "_j0-8";